
const voci = [...document.querySelectorAll('.legal__index-link')];
const sezioni = voci.map((voce) => document.querySelector(voce.getAttribute('href') || ''));

const aggiorna = () => {
  const soglia = window.scrollY + window.innerHeight / 4;
  let attiva = 0;
  sezioni.forEach((sezione, i) => {
    if (sezione && sezione.getBoundingClientRect().top + window.scrollY <= soglia) attiva = i;
  });
  voci.forEach((voce, i) => {
    if (i === attiva) voce.setAttribute('aria-current', 'true');
    else voce.removeAttribute('aria-current');
  });
};

if (voci.length > 1) {
  window.addEventListener('scroll', aggiorna, { passive: true });
  aggiorna();
}
